module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionXscjMobile.e8b4f7e1.png";